// @flow
import type { LeafRuleProps } from 'types/rule-types';
import type { Country } from 'types/country';
import type { StoreState } from 'reducers';

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown } from 'semantic-grab-ui/src';

import GeofenceAddModal from './GeofenceAddModal';
import GeofenceDisplayModal from './GeofenceDisplayModal';
import './GeoRule.scss';
import {
  operatorOptions,
  getOperatorDisp,
} from 'omega-rtc/components/rule-builder/utils';

type Props = LeafRuleProps & {
  countryID: any,
  countries: Array<Country>,
};

class GeoRule extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      showAdd: false,
      showDisplay: false,
    };
  }

  handleRuleOperatorSelect = (event: Object, dropdown: Object) => {
    const { rule } = this.props;
    const newRule = Object.assign({}, rule, { operator: dropdown.value });
    this.props.onRuleChange(newRule);
  }

  UNSAFE_componentWillMount() {
    if (_.isEmpty(this.props.rule.rhs)) {
      this.setState({ showAdd: true });
    }
  }

  handleChange = (geofence: Object) => {
    this.setState({ showAdd: false });

    if (geofence === undefined && this.props.rule.rhs === '') {
      this.props.onRuleRemove();
    }

    if (geofence !== undefined) {
      const { rule } = this.props;
      rule.rhs = geofence;
      this.props.onRuleChange(rule);
    }
  }

  handleShow = () => {
    this.setState({ showDisplay: true });
  }

  handleShowChange = (shouldEdit: boolean) => {
    this.setState({ showDisplay: false, showAdd: shouldEdit });
  }

  render() {
    const { rule, isSelected, ruleType, countries, countryID, readonly } = this.props;
    const allCities = countries.reduce((cities, country) => cities.concat(country.cities), []);
    const cities = _.get(_.find(countries, c => c.countryID === countryID), 'cities', allCities);
    const title = _.get(this.props, 'ruleType.noun');

    return (
      <span>
        <span>{ruleType.noun}</span>
        <span className="horizontal-margin">
          <Dropdown
            inline
            trigger={<span className="rule-field">{getOperatorDisp(rule.operator)}</span>}
            options={operatorOptions(ruleType)}
            defaultValue={rule.operator}
            onChange={this.handleRuleOperatorSelect}
            disabled={!isSelected}
          />
        </span>
        <Button className="horizontal-margin" onClick={this.handleShow}>
          {_.get(rule, 'rhs.name') || _.get(rule, 'rhs.code')}
        </Button>
        <GeofenceAddModal
          show={this.state.showAdd}
          onChange={this.handleChange}
          title={title}
          cities={cities}
        />
        <GeofenceDisplayModal
          show={this.state.showDisplay}
          geofence={rule.rhs}
          onChange={this.handleShowChange}
          canEdit={!readonly}
        />
      </span>
    );
  }
}


export function mapStateToProps(state: StoreState, ownProps: Object) {
  let customProps = {};
  if (ownProps.customSelector) {
    customProps = ownProps.customSelector(state);
  }
  return {
    countryID: null,
    countries: state.countries.entities,
    ...customProps,
  };
}

export default connect(mapStateToProps)(GeoRule);
